import React, { useRef, useState } from 'react';
import { InputMask, format } from '@react-input/mask';
import { useForm, useFormState } from 'react-final-form';
import { Icon } from '../../Icon';
import { scrollInputToCenter } from '../../../utils/helpers/common';
import {
  StyledPhoneMask,
  StyledTextField,
  StyledTextLabel,
  TextFieldContainer
} from './styled';
import { MaskedPhoneInputProps } from './types';

const PHONE_MASK_OPTIONS = {
  mask: '(0A_) ___-__-__',
  replacement: { A: /[1-9]/, _: /\d/ }
} as const;

export const MaskedPhoneInput: React.FC<MaskedPhoneInputProps> = ({
  icon,
  name,
  onClick,
  disabled = false,
  placeholder,
  showPhoneMask = false
}) => {
  const { change } = useForm();
  const { values } = useFormState({
    subscription: { values: true }
  });
  const value = values[name] === undefined ? '' : values[name];
  const formattedValue = value
    ? format(String(value), PHONE_MASK_OPTIONS)
    : value;
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const focusInput = () => {
    setIsFocused(true);
    inputRef.current?.focus();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/[^\d]/g, '');
    change(name, rawValue);
  };

  const scrollHandler = () => scrollInputToCenter(inputRef.current);

  const phoneMask = '(000) 000-00-00';

  return (
    <TextFieldContainer data-cy="text-field-container">
      <StyledTextField onClick={onClick} data-cy="text-field">
        <StyledTextLabel
          role="presentation"
          onClick={focusInput}
          $isActive={isFocused || value}
        >
          {placeholder}
        </StyledTextLabel>
        <InputMask
          {...PHONE_MASK_OPTIONS}
          ref={inputRef}
          pattern="[0-9]*"
          autoComplete="off"
          inputMode="numeric"
          disabled={disabled}
          data-cy="phone-input"
          onFocus={() => {
            setIsFocused(true);
            scrollHandler();
          }}
          onBlur={() => setIsFocused(false)}
          onChange={handleInputChange}
          className="masked-input-field"
          value={value ? formattedValue : value}
        />
        {showPhoneMask && !value && isFocused && (
          <StyledPhoneMask tag="body_1">{phoneMask}</StyledPhoneMask>
        )}
      </StyledTextField>

      {icon && (
        <Icon IconComponent={icon} width={35} height={35} indent={false} />
      )}
    </TextFieldContainer>
  );
};
